import { combineReducers } from 'redux';
import { adGroupsReducer } from './ad-groups/ad-groups.state';
import { adSetsReducer } from './ad-sets/ad-sets.state';

export const advertisingReducer = combineReducers({
    adGroups: adGroupsReducer,
    adSets: adSetsReducer,
});
